import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { B2bHome } from './types';

export function useB2bHomeData(): Page<B2bHome>['templateFields'] {
  return useCurrentPage<Page<B2bHome>>().templateFields;
}
